var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCustomPaperclip = function SvgCustomPaperclip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 8.333v6.334c0 1.68-.738 3.29-2.05 4.478C15.637 20.333 13.857 21 12 21c-1.857 0-3.637-.667-4.95-1.855C5.737 17.957 5 16.346 5 14.667V6.222c0-1.12.492-2.194 1.367-2.985C7.242 2.445 8.429 2 9.667 2c1.237 0 2.424.445 3.3 1.237.875.791 1.366 1.865 1.366 2.985v8.445c0 .56-.245 1.097-.683 1.492a2.463 2.463 0 0 1-1.65.619 2.463 2.463 0 0 1-1.65-.619 2.014 2.014 0 0 1-.683-1.492V6.222",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgCustomPaperclip;